import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3Icon, ShieldIcon, TrendingUpIcon } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-white" data-id="element-11" data-mp="2prqlsjg1m6e7">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12" data-mp="2tssoxbd2z2lg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-13" data-mp="2tvetr38l73zz">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-navy mb-6" data-id="element-14" data-mp="3dickhk45qebj">
            About the Team
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-15" data-mp="3hkhewl2fjez8">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-16" data-mp="3mjarmb9w71yc">
            <div className="relative" data-id="element-17" data-mp="2cq9bdfcdzig5">
              <div className="aspect-square rounded-lg overflow-hidden bg-gradient-to-br from-navy to-charcoal" data-id="element-18" data-mp="2crbzxgm8l8sw">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=800&auto=format&fit=crop" alt="Trevor Williams" className="w-full h-full object-cover opacity-90" data-id="element-19" data-mp="27t0s1bfi58db" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-gold text-navy px-6 py-3 rounded-lg font-bold" data-id="element-20" data-mp="2vodari2h234r">
                Founder & Principal
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-21" data-mp="3o6hfvmbdp3ug">
            <h3 className="text-3xl font-serif font-bold text-navy mb-4" data-id="element-22" data-mp="b6rjn4zcpsn8">
              Trevor Williams
            </h3>
            <p className="text-lg text-slate mb-6 leading-relaxed" data-id="element-23" data-mp="1elq3qtgb35x">
              Trevor has spent over a decade analyzing and investing in Cabo San
              Lucas real estate. His approach is rooted in data, not hype —
              every deal recommendation is backed by quantified metrics and
              independent research.
            </p>
            <p className="text-lg text-slate mb-6 leading-relaxed" data-id="element-24" data-mp="3alv36csor7oz">
              Before launching Cabo Deal Flow, Trevor worked with private family
              offices and high-net-worth individuals to source off-market
              opportunities across Mexico's Pacific coast. He recognized a gap
              in the market: sophisticated investors needed curated,
              institutional-grade deal flow without the noise of traditional
              listing sites.
            </p>

            <div className="space-y-4 mt-8" data-id="element-25" data-mp="2tcaoaskukrqx">
              <div className="flex items-start" data-id="element-26" data-mp="371uq9w6ltkz6">
                <BarChart3Icon className="text-gold mr-3 mt-1 flex-shrink-0" size={24} data-id="element-27" data-mp="373p994ybf30m" />
                <div data-id="element-28" data-mp="3h0aiy3la52as">
                  <h4 className="font-semibold text-navy mb-1" data-id="element-29" data-mp="3gzix3khhiixp">
                    Data-Driven Philosophy
                  </h4>
                  <p className="text-slate text-sm" data-id="element-30" data-mp="3c0pfbfv605rq">
                    Every deal is evaluated on cash flow, ROI, and equity
                    potential — not marketing narratives.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-31" data-mp="1vmpjafzfx09r">
                <ShieldIcon className="text-gold mr-3 mt-1 flex-shrink-0" size={24} data-id="element-32" data-mp="1vnhevqt1ey01" />
                <div data-id="element-33" data-mp="1t2jhoeyatlwd">
                  <h4 className="font-semibold text-navy mb-1" data-id="element-34" data-mp="1t32oazii0nv3">
                    Privacy-First Approach
                  </h4>
                  <p className="text-slate text-sm" data-id="element-35" data-mp="1x2tofttx0gca">
                    No cold calls, no spam. Investors control the relationship
                    and engage when ready.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-36" data-mp="26zy9trfxs7s1">
                <TrendingUpIcon className="text-gold mr-3 mt-1 flex-shrink-0" size={24} data-id="element-37" data-mp="19fljjd0ef9as" />
                <div data-id="element-38" data-mp="1ebajvik8su85">
                  <h4 className="font-semibold text-navy mb-1" data-id="element-39" data-mp="1jczuwy7gt7w8">
                    Investor-First Mindset
                  </h4>
                  <p className="text-slate text-sm" data-id="element-40" data-mp="1o4hvvm9hn8h7">
                    Focused on long-term relationships and sustainable returns,
                    not quick commissions.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}